export default __webpack_public_path__ + "static/media/Group 8.f41797a5.png";